module.exports = __webpack_public_path__ + "img/psdicon.5f3075ab.png";